import type React from 'react'

type HandleTabsKeyDownParams = {
  event: React.KeyboardEvent<HTMLButtonElement>
  currentIndex: number
  tabsLength: number
  onSelectTab: (nextTabIndex: number) => void
}

export function handleTabsKeyDown({
  event,
  currentIndex,
  tabsLength,
  onSelectTab,
}: HandleTabsKeyDownParams) {
  if (!tabsLength || currentIndex < 0) {
    return
  }

  if (event.key === 'ArrowRight') {
    event.preventDefault()
    const nextIndex = (currentIndex + 1) % tabsLength

    onSelectTab(nextIndex)
  }

  if (event.key === 'ArrowLeft') {
    event.preventDefault()
    const nextIndex = (currentIndex - 1 + tabsLength) % tabsLength

    onSelectTab(nextIndex)
  }

  if (event.key === 'Home') {
    event.preventDefault()
    onSelectTab(0)
  }

  if (event.key === 'End') {
    event.preventDefault()
    onSelectTab(tabsLength - 1)
  }
}
